const strokeWidthIcon = (color = "currentColor") => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2 3.14C2 2.78654 2.28654 2.5 2.64 2.5H13.36C13.7135 2.5 14 2.78654 14 3.14C14 3.49346 13.7135 3.78 13.36 3.78H2.64C2.28654 3.78 2 3.49346 2 3.14Z"
				fill={color}
			/>
			<path
				d="M2 6.23333C2 5.79151 2.35817 5.43333 2.8 5.43333H13.2C13.6418 5.43333 14 5.79151 14 6.23333C14 6.67516 13.6418 7.03333 13.2 7.03333H2.8C2.35817 7.03333 2 6.67516 2 6.23333Z"
				fill={color}
			/>
			<path
				d="M2 9.48667C2 9.04484 2.35817 8.68667 2.8 8.68667H13.2C13.6418 8.68667 14 9.04484 14 9.48667V9.80667C14 10.2485 13.6418 10.6067 13.2 10.6067H2.8C2.35817 10.6067 2 10.2485 2 9.80667V9.48667Z"
				fill={color}
			/>
			<path
				d="M2 13.06C2 12.6182 2.35817 12.26 2.8 12.26H13.2C13.6418 12.26 14 12.6182 14 13.06V13.7C14 14.1418 13.6418 14.5 13.2 14.5H2.8C2.35817 14.5 2 14.1418 2 13.7V13.06Z"
				fill={color}
			/>
		</svg>
	);
};
export default strokeWidthIcon;
